import { api } from "utils";
import {
  fetchSummaryInfo,
  fetchOrderPaymentInfo,
  fetchOrderPaymentInfoList,
  fetchReceivableInfo,
  fetchReceivableInfoList,
  fetchBranchReceivableInfo,
  fetchBranchReceivableInfoList,
  fetchSummaryReceivableInfo,
  fetchBranchPeriodInfo,
  fetchBranchPeriodInfoList,
  fetchSummaryVoucherInfo,
  fetchVoucherInfo,
  fetchVoucherInfoList,
  fetchBranchVoucherInfo,
  fetchBranchVoucherInfoList,
} from "./salesSlice";

import { getCalendar } from "utils/date";

/**
 * 공통 내부 함수
 */

const getChartColorList = (data) => {
  return data.map((item) => (item < 0 ? "#f43e3e" : "#3b79f0"));
};

const getSearchEndDate = (searchPeriodType, searchDate) => {
  const startDate = new Date(searchDate);
  switch (searchPeriodType) {
    case "daily":
      return searchDate;
    case "weekly":
      return startDate.getEndDateInWeek().getCalendar();
    case "monthly":
      return startDate.getEndDateInMonth().getCalendar();
  }
};

/**
 * 일일, 주간, 월간 매출 개요 (홈, 일반 및 지점 상세, 전 지점 상세)
 */

export const updateDailySummaryInfo =
  (searchInfo, action, name) => (dispatch, getState) => {
    const partnerInfo = getState().partner;
    const actionInfo = getState().sales[name];

    const searchPartner =
      searchInfo.searchPartner || partnerInfo.seqPartner || 0;
    const searchBranch =
      searchInfo.searchBranch || partnerInfo.seqPartnerBranch || 0;
    const searchDate = searchInfo.searchDate;
    if (!searchDate || !searchPartner) return;

    const timestamp = Date.now();

    dispatch(
      action({
        searchPartner: searchPartner,
        searchBranch: searchBranch,
        searchDate: searchDate,
        searchPeriodType: "daily",
        data: {
          searchInfo: {
            searchPartner: searchPartner,
            searchBranch: searchBranch,
            searchDate: searchDate,
            searchPeriodType: "daily",
          },
        },
        isLoading: true,
        isError: false,
        timestamp: timestamp,
      })
    );

    api
      .post("/sales/period/daily-sales", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        searchDate: searchDate,
        searchDateCount: searchInfo.searchCount || 7,
        branchUseYn: partnerInfo.branchUseYn || "N",
      })
      .then(({ data }) => {
        const actionInfo = getState().sales[name];
        if (timestamp != actionInfo.timestamp) return;

        const totalInfo = data;
        const summaryList = data.recentSalesList || [];
        const summaryInfo = summaryList[summaryList.length - 1];
        const chartLabel = summaryList.map((item) => {
          const date = new Date(item.date);
          return [date.getDate(), date.getDayName()];
        });
        const chartData = summaryList.map((item) => item.totalSalesAmount);
        dispatch(
          action({
            data: {
              totalInfo,
              searchInfo: {
                searchPartner: searchPartner,
                searchBranch: searchBranch,
                searchDate: searchDate,
                searchPeriodType: "daily",
              },
              summaryInfo: summaryInfo,
              summaryList: summaryList,
              chartInfo: {
                labels: chartLabel,
                datasets: [
                  {
                    data: chartData,
                    backgroundColor: getChartColorList(chartData),
                    borderRadius: {
                      topLeft: 4,
                      topRight: 4,
                    },
                    barPercentage: 0.4,
                    categoryPercentage: 1,
                  },
                ],
              },
            },
            isLoading: false,
          })
        );
      })
      .catch((error) => {
        const actionInfo = getState().sales[name];
        if (timestamp != actionInfo.timestamp) return;
        console.log(error);
        dispatch(
          action({
            isLoading: false,
            isError: true,
          })
        );
      });
  };

export const updateWeeklySummaryInfo =
  (searchInfo, action, name) => (dispatch, getState) => {
    const actionInfo = getState().sales[name];
    const partnerInfo = getState().partner;
    const searchPartner =
      searchInfo.searchPartner || partnerInfo.seqPartner || 0;
    const searchBranch =
      searchInfo.searchBranch || partnerInfo.seqPartnerBranch || 0;
    const searchDate = searchInfo.searchDate;
    if (!searchDate || !searchPartner) return;

    const timestamp = Date.now();

    dispatch(
      action({
        searchPartner: searchPartner,
        searchBranch: searchBranch,
        searchDate: searchDate,
        searchPeriodType: "weekly",
        data: {
          searchInfo: {
            searchPartner: searchPartner,
            searchBranch: searchBranch,
            searchDate: searchDate,
            searchPeriodType: "weekly",
          },
        },
        isLoading: true,
        isError: false,
        timestamp: timestamp,
      })
    );

    api
      .post("/sales/period/weekly-sales", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        searchDate: new Date(searchDate).getEndDateInWeek().getCalendar(),
        searchWeekCount: searchInfo.searchCount || 6,
        branchUseYn: partnerInfo.branchUseYn || "N",
      })
      .then(({ data }) => {
        const actionInfo = getState().sales[name];
        if (timestamp != actionInfo.timestamp) return;

        const summaryList = data.weeklySalesList || [];
        const summaryInfo = summaryList[summaryList.length - 1];
        const chartLabel = summaryList.map((item) => {
          const date = new Date(item.startDate);
          date.setDate(date.getDate() + 3);
          const month = date.getMonth() + 1 + "월";
          const week = date.getWeekInMonth() + "주차";
          return [month, week];
        });
        const chartData = summaryList.map((item) => item.totalSalesAmount);
        dispatch(
          action({
            data: {
              searchInfo: {
                searchPartner: searchPartner,
                searchBranch: searchBranch,
                searchDate: searchDate,
                searchPeriodType: "weekly",
              },
              summaryInfo: summaryInfo,
              summaryList: summaryList,
              chartInfo: {
                labels: chartLabel,
                datasets: [
                  {
                    data: chartData,
                    backgroundColor: getChartColorList(chartData),
                    borderRadius: {
                      topLeft: 4,
                      topRight: 4,
                    },
                    barPercentage: 0.4,
                    categoryPercentage: 1,
                  },
                ],
              },
            },
            isLoading: false,
          })
        );
      })
      .catch((error) => {
        const actionInfo = getState().sales[name];
        if (timestamp != actionInfo.timestamp) return;
        console.log(error);
        dispatch(
          action({
            isLoading: false,
            isError: true,
          })
        );
      });
  };

export const updateMonthlySummaryInfo =
  (searchInfo, action, name) => (dispatch, getState) => {
    const actionInfo = getState().sales[name];
    const partnerInfo = getState().partner;
    const searchPartner =
      searchInfo.searchPartner || partnerInfo.seqPartner || 0;
    const searchBranch =
      searchInfo.searchBranch || partnerInfo.seqPartnerBranch || 0;
    const searchDate = searchInfo.searchDate;
    if (!searchDate || !searchPartner) return;

    const timestamp = Date.now();

    dispatch(
      action({
        searchPartner: searchPartner,
        searchBranch: searchBranch,
        searchDate: searchDate,
        searchPeriodType: "monthly",
        data: {
          searchInfo: {
            searchPartner: searchPartner,
            searchBranch: searchBranch,
            searchDate: searchDate,
            searchPeriodType: "monthly",
          },
        },
        isLoading: true,
        isError: false,
        timestamp: timestamp,
      })
    );

    api
      .post("/sales/period/monthly-sales", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        searchMonth: searchDate.substr(0, 7),
        searchMonthCount: searchInfo.searchCount || 6,
        branchUseYn: partnerInfo.branchUseYn || "N",
      })
      .then(({ data }) => {
        const actionInfo = getState().sales[name];
        if (timestamp != actionInfo.timestamp) return;

        const summaryList = data.monthlySalesList || [];
        const summaryInfo = summaryList[summaryList.length - 1];
        const chartLabel = summaryList.map((item) => {
          const date = new Date(item.yearMonth + "-01");
          const month = date.getMonth() + 1 + "월";
          return month;
        });
        const chartData = summaryList.map((item) => item.totalSalesAmount);

        dispatch(
          action({
            data: {
              searchInfo: {
                searchPartner: searchPartner,
                searchBranch: searchBranch,
                searchDate: searchDate,
                searchPeriodType: "monthly",
              },
              summaryInfo: summaryInfo,
              summaryList: summaryList,
              chartInfo: {
                labels: chartLabel,
                datasets: [
                  {
                    data: chartData,
                    backgroundColor: getChartColorList(chartData),
                    borderRadius: {
                      topLeft: 4,
                      topRight: 4,
                    },
                    barPercentage: 0.4,
                    categoryPercentage: 1,
                  },
                ],
              },
            },
            isLoading: false,
          })
        );
      })
      .catch((error) => {
        const actionInfo = getState().sales[name];
        if (timestamp != actionInfo.timestamp) return;

        console.log(error);
        dispatch(
          action({
            isLoading: false,
            isError: true,
          })
        );
      });
  };

/**
 * 이용권 종류별 매출 관련
 */

export const updateVoucherInfo =
  (searchInfo, action, name) => (dispatch, getState) => {
    const actionInfo = getState().sales[name];
    const partnerInfo = getState().partner;
    const searchPartner = searchInfo.searchPartner || 0;
    const searchBranch = searchInfo.searchBranch || 0;
    const searchDate = searchInfo.searchDate;
    const searchPeriodType = searchInfo.searchPeriodType || "daily";
    const searchFilter = searchInfo.searchFilter || "";

    if (!searchDate || !searchPartner) return;

    const timestamp = Date.now();

    const startDate = searchDate;
    const endDate = (() => {
      const startDate = new Date(searchDate);
      switch (searchPeriodType) {
        case "daily":
          return searchDate;
        case "weekly":
          return startDate.getEndDateInWeek().getCalendar();
        case "monthly":
          return startDate.getEndDateInMonth().getCalendar();
      }
    })();

    dispatch(
      action({
        searchPartner: searchPartner,
        searchBranch: searchBranch,
        searchDate: searchDate,
        searchPeriodType: searchPeriodType,
        searchFilter: searchFilter,
        isLoading: true,
        isError: false,
        timestamp: timestamp,
      })
    );

    api
      .post("/sales/services/summary", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        startDate: startDate,
        endDate: endDate,
        branchUseYn: partnerInfo.branchUseYn || "N",
      })
      .then(({ data }) => {
        const actionInfo = getState().sales[name];
        if (timestamp == actionInfo.timestamp) {
          dispatch(
            action({
              data: {
                searchInfo: {
                  searchPartner: searchPartner,
                  searchBranch: searchBranch,
                  searchDate: searchDate,
                  searchPeriodType: searchPeriodType,
                  searchFilter: searchFilter,
                },
                summaryInfo: {
                  totalSalesAmount: data.totalSalesAmount,
                },
                voucherInfo: data,
              },
              isLoading: false,
            })
          );
        }
      })
      .catch((error) => {
        const actionInfo = getState().sales[name];
        if (timestamp == actionInfo.timestamp) {
          dispatch(
            action({
              isLoading: false,
              isError: true,
            })
          );
        }
      });
  };

export const updateVoucherInfoList = (isUpdate) => (dispatch, getState) => {
  const voucherInfo = getState().sales.voucherInfo;
  const partnerInfo = getState().partner;

  const searchPartner = voucherInfo.searchPartner;
  const searchBranch = voucherInfo.searchBranch;
  const searchDate = voucherInfo.searchDate;
  const searchPeriodType = voucherInfo.searchPeriodType;
  const searchFilter = voucherInfo.searchFilter || "ALL";

  if (!searchPartner || !searchDate) return;

  const startDate = voucherInfo.searchDate;
  const endDate = getSearchEndDate(
    voucherInfo.searchPeriodType,
    voucherInfo.searchDate
  );

  if (isUpdate) {
    dispatch(
      fetchVoucherInfo({
        pageState: undefined,
      })
    );

    api
      .post("/sales/services", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        startDate: startDate,
        endDate: endDate,
        filter: searchFilter,
        criteria: {
          page: voucherInfo.page,
          pageSize: voucherInfo.pageSize,
        },
        branchUseYn: "Y",
        lastSeqOrderPayment: voucherInfo.dataList.lastSeqOrderPayment,
        lastSeqRefundInfo: voucherInfo.dataList.lastSeqRefundInfo,
      })
      .then(({ data }) => {
        const paymentList = (data.page || {}).results || [];
        dispatch(
          fetchVoucherInfoList({
            paymentList: paymentList || [],
            lastSeqOrderPayment: data.lastSeqOrderPayment || 0,
            lastSeqRefundInfo: data.lastSeqRefundInfo || 0,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          fetchVoucherInfo({
            pageState: false,
          })
        );
      });
  } else {
    dispatch(
      fetchVoucherInfo({
        dataList: {
          searchInfo: {
            searchPartner: voucherInfo.searchPartner,
            searchBranch: voucherInfo.searchBranch,
            searchDate: voucherInfo.searchDate,
            searchPeriodType: voucherInfo.searchPeriodType,
            searchFilter: voucherInfo.searchFilter,
          },
          paymentList: [],
          lastSeqOrderPayment: 0,
          lastSeqRefundInfo: 0,
        },
        page: 1,
        pageState: true,
      })
    );
  }
};

export const updateBranchVoucherInfoList =
  (isUpdate) => (dispatch, getState) => {
    const partnerInfo = getState().partner;
    const branchVoucherInfo = getState().sales.branchVoucherInfo;
    const searchPartner = branchVoucherInfo.searchPartner;
    const searchDate = branchVoucherInfo.searchDate;
    const searchOrder = branchVoucherInfo.searchFilter || "SALES";
    if (!searchPartner || !searchDate) return;

    const startDate = branchVoucherInfo.searchDate;
    const endDate = getSearchEndDate(
      branchVoucherInfo.searchPeriodType,
      branchVoucherInfo.searchDate
    );

    if (isUpdate) {
      dispatch(
        fetchBranchVoucherInfo({
          pageState: undefined,
        })
      );
      api
        .post("/sales/services/branches/summary", {
          seqPartner: searchPartner,
          searchOrder: searchOrder,
          startDate: startDate,
          endDate: endDate,
          criteria: {
            page: branchVoucherInfo.page,
            pageSize: branchVoucherInfo.pageSize,
          },
        })
        .then(({ data }) => {
          const branchList = (data.page || {}).results || [];
          dispatch(fetchBranchVoucherInfoList(branchList));
        })
        .catch((error) => {
          console.log(error);
          dispatch(
            fetchBranchVoucherInfo({
              pageState: false,
            })
          );
        });
    } else {
      dispatch(
        fetchBranchVoucherInfo({
          dataList: [],
          page: 1,
          pageState: true,
        })
      );
    }
  };

/**
 * 전 지점 매출 개요 목록
 */

export const updateBranchPeriodInfo = (isUpdate) => (dispatch, getState) => {
  const branchSummaryInfo = getState().sales.branchSummaryInfo;
  const branchPeriodInfo = getState().sales.branchPeriodInfo;
  const partnerInfo = getState().partner;

  const searchPartner = branchSummaryInfo.searchPartner;
  const searchDate = branchSummaryInfo.searchDate;
  const searchPeriodType = branchSummaryInfo.searchPeriodType;
  const searchFilter = branchSummaryInfo.searchFilter || "SALES";

  if (!searchPartner || !searchDate) return;

  const startDate = searchDate;
  const endDate = getSearchEndDate(searchPeriodType, searchDate);

  const fetchUrl = (() => {
    switch (searchPeriodType) {
      case "daily":
        return "/sales/integrated/daily-sales-detail";
      case "weekly":
        return "/sales/integrated/weekly-sales-detail";
      case "monthly":
        return "/sales/integrated/monthly-sales-detail";
    }
  })();

  const fetchData = (() => {
    const data = {
      seqPartner: partnerInfo.seqPartner,
      criteria: {
        page: branchPeriodInfo.page,
        pageSize: branchPeriodInfo.pageSize,
      },
      searchOrder: searchFilter,
      sort: searchFilter == "SALES" ? "DESC" : "ASC",
    };
    switch (searchPeriodType) {
      case "daily":
        data.searchDate = searchDate;
        break;
      case "weekly":
        data.searchDate = endDate;
        break;
      case "monthly":
        data.searchMonth = searchDate.substr(0, 7);
        break;
    }
    return data;
  })();

  if (isUpdate) {
    const timestamp = Date.now();

    dispatch(
      fetchBranchPeriodInfo({
        pageState: undefined,
        timestamp: timestamp,
      })
    );
    api
      .post(fetchUrl, fetchData)
      .then(({ data }) => {
        const actionInfo = getState().sales.branchPeriodInfo;
        if (timestamp == actionInfo.timestamp) {
          const overviewList =
            (
              data.dailyBranchSalesDetails ||
              data.weeklyBranchSalesDetails ||
              data.monthlyBranchSalesDetails ||
              {}
            ).results || [];
          dispatch(fetchBranchPeriodInfoList(overviewList));
        }
      })
      .catch((error) => {
        const actionInfo = getState().sales.branchPeriodInfo;
        if (timestamp == actionInfo.timestamp) {
          console.log(error);
          dispatch(
            fetchBranchPeriodInfo({
              pageState: false,
            })
          );
        }
      });
  } else {
    dispatch(
      fetchBranchPeriodInfo({
        data: {
          searchInfo: {
            searchPartner: branchSummaryInfo.searchPartner,
            searchBranch: branchSummaryInfo.searchBranch,
            searchDate: branchSummaryInfo.searchDate,
            searchPeriodType: branchSummaryInfo.searchPeriodType,
            searchFilter: branchSummaryInfo.searchFilter,
          },
          overviewList: [],
        },
        page: 1,
        pageState: true,
      })
    );
  }
};

/**
 * 주문 결제 내역 목록
 */

export const updateOrderPaymentList = (isUpdate) => (dispatch, getState) => {
  const detailSummaryInfo = getState().sales.detailSummaryInfo;
  const paymentInfo = getState().sales.orderPaymentInfo;
  const partnerInfo = getState().partner;

  const searchPartner = detailSummaryInfo.searchPartner;
  const searchBranch = detailSummaryInfo.searchBranch;
  const searchDate = detailSummaryInfo.searchDate;
  const searchPeriodType = detailSummaryInfo.searchPeriodType;
  const searchFilter = detailSummaryInfo.searchFilter;

  if (!searchPartner || !searchDate) return;

  const startDate = searchDate;
  const endDate = getSearchEndDate(searchPeriodType, searchDate);

  if (isUpdate) {
    const timestamp = Date.now();

    dispatch(
      fetchOrderPaymentInfo({
        pageState: undefined,
        timestamp: timestamp,
      })
    );

    api
      .post("/sales/period/total-sales-by-day", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        startDate: searchDate,
        endDate: endDate,
        filter: searchFilter || "ALL",
        criteria: {
          page: paymentInfo.page,
          pageSize: paymentInfo.pageSize,
        },
        branchUseYn: "Y",
        lastSeqOrderPayment: paymentInfo.lastSeqOrderPayment,
        lastSeqRefundInfo: paymentInfo.lastSeqRefundInfo,
      })
      .then(({ data }) => {
        const orderPaymentInfo = getState().sales.orderPaymentInfo;
        if (timestamp == orderPaymentInfo.timestamp) {
          const paymentList = (data.page || {}).results || [];
          dispatch(
            fetchOrderPaymentInfoList({
              paymentList: paymentList || [],
              lastSeqOrderPayment: data.lastSeqOrderPayment || 0,
              lastSeqRefundInfo: data.lastSeqRefundInfo || 0,
            })
          );
        }
      })
      .catch((error) => {
        const orderPaymentInfo = getState().sales.orderPaymentInfo;
        if (timestamp == orderPaymentInfo.timestamp) {
          console.log(error);
          dispatch(
            fetchOrderPaymentInfo({
              pageState: false,
            })
          );
        }
      });
  } else {
    dispatch(
      fetchOrderPaymentInfo({
        data: {
          searchInfo: {
            searchPartner: searchPartner,
            searchBranch: searchBranch,
            searchDate: searchDate,
            searchPeriodType: searchPeriodType,
            searchFilter: searchFilter,
          },
          paymentList: [],
        },
        page: 1,
        pageState: true,
        lastSeqOrderPayment: 0,
        lastSeqRefundInfo: 0,
      })
    );
  }
};

/**
 * 현재 누적 미수금 관련
 */

export const updateReceivableInfo =
  (searchInfo, action) => (dispatch, getState) => {
    const partnerInfo = getState().partner;
    const searchPartner = searchInfo.searchPartner || 0;
    const searchBranch = searchInfo.searchBranch || 0;
    const branchUseYn =
      searchInfo.branchUseYn || partnerInfo.branchUseYn || "N";
    const searchDate = searchInfo.searchDate;

    if (!searchDate || !searchPartner) return;

    const fetchUrl = "/sales/accumulate-receivables";
    const fetchData = {
      seqPartner: searchPartner,
      seqPartnerBranch: searchBranch,
      branchUseYn: branchUseYn,
    };

    dispatch(
      action({
        searchPartner: searchPartner,
        searchBranch: searchBranch,
        searchDate: searchDate,
        isLoading: true,
        isError: false,
      })
    );
    api
      .post(fetchUrl, fetchData)
      .then(({ data }) => {
        const receivableAmount = data.accumulateReceivables || 0;
        dispatch(
          action({
            data: {
              searchInfo: {
                searchPartner: searchPartner,
                searchBranch: searchBranch,
                searchDate: searchDate,
              },
              receivableAmount: receivableAmount,
            },
            isLoading: false,
            isError: false,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          action({
            isLoading: false,
            isError: true,
          })
        );
      });
  };

export const updateReceivableInfoList = (isUpdate) => (dispatch, getState) => {
  const partnerInfo = getState().partner;
  const receivableInfo = getState().sales.receivableInfo;

  const searchPartner = receivableInfo.searchPartner || 0;
  const searchBranch = receivableInfo.searchBranch || 0;
  const searchDate = receivableInfo.searchDate;

  if (!searchDate || !searchPartner) return;

  if (isUpdate) {
    dispatch(
      fetchReceivableInfo({
        pageState: undefined,
      })
    );
    api
      .post("/sales/normal-center/receivables", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        criteria: {
          page: receivableInfo.page,
          pageSize: receivableInfo.pageSize,
        },
      })
      .then(({ data }) => {
        const receivableList =
          (data.normalCenterReceivableItems || {}).results || [];
        dispatch(fetchReceivableInfoList(receivableList));
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          fetchReceivableInfo({
            pageState: false,
          })
        );
      });
  } else {
    dispatch(
      fetchReceivableInfo({
        dataList: [],
        page: 1,
        pageState: true,
      })
    );
  }
};

export const updateBranchReceivableInfoList =
  (isUpdate) => (dispatch, getState) => {
    const partnerInfo = getState().partner;
    const branchReceivableInfo = getState().sales.branchReceivableInfo;
    const searchPartner = branchReceivableInfo.searchPartner || 0;
    const searchDate = branchReceivableInfo.searchDate;
    if (!searchDate || !searchPartner) return;

    if (isUpdate) {
      dispatch(
        fetchBranchReceivableInfo({
          pageState: undefined,
        })
      );
      api
        .post("/sales/integrated-center/receivables", {
          seqPartner: searchPartner,
          criteria: {
            page: branchReceivableInfo.page,
            pageSize: branchReceivableInfo.pageSize,
          },
        })
        .then(({ data }) => {
          const branchReceivableList =
            (data.integratedCenterReceivableItems || {}).results || [];
          dispatch(fetchBranchReceivableInfoList(branchReceivableList));
        })
        .catch((error) => {
          console.log(error);
          dispatch(
            fetchBranchReceivableInfo({
              pageState: false,
            })
          );
        });
    } else {
      dispatch(
        fetchBranchReceivableInfo({
          dataList: [],
          page: 1,
          pageState: true,
        })
      );
    }
  };
